/**
 * Converts a features array to GeoJSON format.
 * Exports circles as Point geometry with radius/z in properties
 * so that imported files correctly reconstruct circles.
 */
export function featuresToGeoJSON(features) {
  return {
    type: "FeatureCollection",
    features: features.map(f => {
      // Hantera cirklar (från drawing tools eller importerade)
      if (
        (f.geometry.type === "Circle" && f.geometry.center && f.geometry.radius) ||
        (f.geometry._originalType === "Circle" && f.geometry.center && f.geometry.radius)
      ) {
        const [lng, lat] = f.geometry.center;
        const z = f.geometry.z ?? 0;
        
        // Export circles as Point geometry with radius/z in properties so that
        // re-importing the file correctly reconstructs the circle (not a polygon).
        const circleProperties = { 
          ...f.properties, 
          radius: f.geometry.radius, 
          z, 
          _originalType: "Circle" 
        };
        
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [lng, lat, z]
          },
          properties: circleProperties
        };
      }
      // Hantera Polygon
      else if (f.geometry.type === "Polygon" && f.geometry.coordinates) {
        return {
          type: "Feature",
          geometry: {
            ...f.geometry,
            coordinates: f.geometry.coordinates.map(ring =>
              ring.map(coord =>
                coord.length === 3
                  ? [coord[0], coord[1], coord[2]]
                  : [coord[0], coord[1], 0]
              )
            )
          },
          properties: { ...f.properties }
        };
      }
      // Hantera MultiPolygon
      else if (f.geometry.type === "MultiPolygon" && f.geometry.coordinates) {
        return {
          type: "Feature",
          geometry: {
            ...f.geometry,
            coordinates: f.geometry.coordinates.map(polygon =>
              polygon.map(ring =>
                ring.map(coord =>
                  coord.length === 3
                    ? [coord[0], coord[1], coord[2]]
                    : [coord[0], coord[1], 0]
                )
              )
            )
          },
          properties: { ...f.properties }
        };
      }
      // Hantera LineString
      else if (f.geometry.type === "LineString" && f.geometry.coordinates) {
        return {
          type: "Feature",
          geometry: {
            ...f.geometry,
            coordinates: f.geometry.coordinates.map(coord =>
              coord.length === 3
                ? [coord[0], coord[1], coord[2]]
                : [coord[0], coord[1], 0]
            )
          },
          properties: { ...f.properties }
        };
      }
      // Hantera Point
      else if (f.geometry.type === "Point" && f.geometry.coordinates) {
        return {
          type: "Feature",
          geometry: {
            ...f.geometry,
            coordinates: f.geometry.coordinates.length === 3
              ? f.geometry.coordinates
              : [f.geometry.coordinates[0], f.geometry.coordinates[1], 0]
          },
          properties: { ...f.properties }
        };
      }
      // Fallback: exportera som det är
      else {
        return {
          type: "Feature",
          geometry: f.geometry,
          properties: { ...f.properties }
        };
      }
    })
  };
}